'use client'

import type { NavGroup } from '@graftcode/design-system'

import { AppVariant } from '@common/core/enums'

import { BaseMobileMenu } from '../../BaseMobileMenu'

import { AcademyNavigation } from './components/AcademyNavigation'
import { useMobileNavigation } from './hooks/useMobileNavigation'
import type { AcademyMobileMenuProps } from './types'

const EMPTY_MENU_GROUPS: NavGroup[] = []

export function AcademyMobileMenu({
  isOpen,
  onClose,
  onNavigationClick,
  tutorialSections = [],
  currentTutorialPath,
  categoryTree,
  rootArticles,
}: AcademyMobileMenuProps) {
  const nav = useMobileNavigation({
    tutorialSections,
    categoryTree,
    rootArticles,
    onNavigationClick,
    onClose,
  })

  return (
    <BaseMobileMenu
      isOpen={isOpen}
      onClose={onClose}
      appVariant={AppVariant.ACADEMY}
      menuGroups={EMPTY_MENU_GROUPS}
      onNavigationClick={onNavigationClick}
      showProjectSelector={false}
      showWorkspaceSelector={false}
      navigationTopSlot={
        <AcademyNavigation nav={nav} tutorialSections={tutorialSections} currentTutorialPath={currentTutorialPath} />
      }
    />
  )
}
